import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Clock } from "lucide-react";
import { SOURCE_META, THEME_META, formatDate } from "../../lib/catalog";

export default function Featured({ articles }) {
  const featured = articles.filter((a) => a.featured);
  if (featured.length === 0) return null;

  return (
    <section id="spotlight" className="scroll-mt-20 relative max-w-[1320px] mx-auto px-5 sm:px-8 py-14 sm:py-16">
      <div className="flex items-end justify-between mb-8 border-b border-[var(--line)] pb-4">
        <div>
          <p className="meta-label text-[var(--gold)]">Editorial Spotlight</p>
          <h2 className="font-serif text-3xl sm:text-4xl mt-2 text-[var(--txt)]">Key Dispatches</h2>
        </div>
        <span className="meta-label text-[var(--muted)] hidden sm:block">{featured.length} selected</span>
      </div>

      <div className="grid md:grid-cols-2 gap-5">
        {featured.map((a, i) => {
          const src = SOURCE_META[a.source];
          const th = THEME_META[a.theme];
          return (
            <motion.a
              key={a.slug}
              data-testid={`featured-card-${a.slug}`}
              href={a.url}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.08, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              className="group relative flex flex-col justify-between p-6 sm:p-7 bg-[var(--surface)] border border-[var(--line)] hover:border-[var(--gold)] transition-colors duration-300 min-h-[230px]"
            >
              <span className="absolute top-0 left-0 w-10 h-[2px]" style={{ backgroundColor: th.color }} />
              <div>
                <div className="flex items-center gap-2.5 flex-wrap">
                  <span className="meta-label px-2.5 py-1 border text-[0.58rem]"
                    style={{ background: src.bg, borderColor: src.border, color: src.text }}>
                    {src.label}
                  </span>
                  <span className="meta-label text-[0.58rem]" style={{ color: th.color }}>{th.code}</span>
                </div>
                <h3 className="font-serif text-[1.6rem] sm:text-[1.8rem] leading-[1.1] mt-4 text-[var(--txt)]">
                  <span className="gold-underline">{a.title}</span>
                </h3>
                <p className="mt-3 text-sm text-[var(--txt-2)] leading-relaxed line-clamp-2">{a.excerpt}</p>
              </div>
              <div className="flex items-center justify-between mt-6 pt-4 border-t border-[var(--line)]">
                <span className="meta-label text-[var(--muted)] text-[0.58rem] flex items-center gap-3">
                  {formatDate(a.date)}
                  {a.read_min > 0 && (
                    <span className="flex items-center gap-1"><Clock size={11} /> {a.read_min} min</span>
                  )}
                </span>
                <span className="flex items-center gap-1 meta-label text-[0.58rem] text-[var(--gold)] group-hover:gap-2 transition-all">
                  Read <ArrowUpRight size={14} />
                </span>
              </div>
            </motion.a>
          );
        })}
      </div>
    </section>
  );
}
